export function isEmptyArray(unknown?: unknown[]): boolean {
  if (!Array.isArray(unknown)) {
    return true;
  }

  return unknown.length === 0;
}
